const BranchConfig = {
    HOURS_TO_CANCEL: 'HOURS_TO_CANCEL',
    TIMEZONE: 'TIMEZONE',
    WEEKS_AHEAD_PLAN_X: 'WEEKS_AHEAD_PLAN_',
  };
  
  export default BranchConfig;
  